<script setup>
import {computed} from 'vue'
import {useToastsStore} from '@/stores/toasts'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store & Pinia Store
const viewStore = useViewStore(props.viewId)
const toastsStore = useToastsStore()

// Computed Properties
const shareUrl = computed(() => {
    return viewStore.shareUrl
})

// Methods
const copyShareToClipboard = async () => {
    try {
        // Explicitly check if the Clipboard API is available (Secure Context check)
        if (!navigator.clipboard || !navigator.clipboard.writeText) {
            throw new Error('Clipboard API not supported or blocked (check if using HTTPS)')
        }

        await navigator.clipboard.writeText(shareUrl.value)

        toastsStore.add({
            body: 'Copied to clipboard.',
        })
    } catch (error) {
        console.warn(error.message)

        // Fallback: Display the URL in the toast so the user can see/copy it manually
        toastsStore.add({
            body: shareUrl.value,
        })
    }
}
</script>

<template>
    <button @click="copyShareToClipboard" class="d-flex align-items-center" type="button">
        <i class="me-2 bi-share"/>
        Share
        <small class="ms-1 badge text-bg-warning">beta</small>
    </button>
</template>